// extracted by mini-css-extract-plugin
export default {"modal_wrap":"ModalBox_modal_wrap__VYg6y","modal_box":"ModalBox_modal_box__-mSo6","check_link":"ModalBox_check_link__NPMI2"};